<template>
  <div>
    <div class="panel--cushion">
      <TextOptionCard
        v-for="(option, index) in options"
        :key="index"
        :class="{'not-more-than-one': options.length <= 1 }"
        :is-active="option == activeOption"
        :is-recommended="checkIsRecommended(option)"
        :option="option"
        @click="handleOptionClick(option)"
      />
    </div>
  </div>
</template>
<script>
import TextOptionCard from "./TextOptionCard.vue";
export default {
  name: "ProductCushionSelector",
  components: {
    TextOptionCard,
  },
  props: {
    cushionOptions: Array,
    selectedProduct: Object,
    defaultProduct: Object,
    shipping: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: this.cushionOptions || [],
      activeIndex: 0,
      activeOption: {},
      defaultOption: {},
      defaultIndex: 0,
      IGNORE_SHIPPING_FABRICS: ["Decide Later", "Customer Own Materials"],
    };
  },
  computed: {
    shippingString() {
      if (!this.IGNORE_SHIPPING_FABRICS.includes(this.selectedProduct.fabric)) {
        return "Timeline Available After Material is Selected";
      }
      let activeBaseTime = parseInt(this.shipping.all);
      if (this.shipping[this.selectedProduct.sku]) {
        activeBaseTime = parseInt(this.shipping[this.selectedProduct.sku]);
      }
      let timeString = `${activeBaseTime} Days`;
      if (activeBaseTime > 14) {
        timeString = `${Math.ceil(activeBaseTime / 7)} Weeks`;
      }
      return `Made in ${timeString}`;
    },
  },
  mounted() {
    const searchParams = new URLSearchParams(window.location.search);
    const setCushion = searchParams.get("cushion");
    this.options.forEach((option) => {
      if (option.sku_code === setCushion) {
        this.activeOption = option;
      }
    });
    this.options.forEach((option) => {
      if (option.title === this.defaultProduct.cushion || option.sku_code == this.getOptionValueMapping()[this.defaultProduct.cushion]) {
        this.defaultOption = option;
      }
    });
  },
  methods: {
    handleOptionClick(option) {
      if (this.activeOption != option) {
        this.activeOption = option;
        this.$emit("cushion-changed", this.activeOption);
      }
    }, 
    checkIsRecommended(option) {
      if (this.options.length > 1) {
        if (option.title == this.defaultOption.title || option.sku_code == this.getOptionValueMapping()[this.defaultOption.title]) {
          return true
        }
      }
      return false
    },
    getOptionValueMapping() {
      // TODO we need to move all these over to SKU CODE
      return {
        // Cushions
        "Foam & Trillium Package":"CT",
        "Foam & Fiber Package":"CF",
        "Standard":"CF",
        "Down Alternative":"CT",
        "Like Butter Foam & Trillium":"CD",
        "Foam Bench Seat & Fiber Pillow Package":"BFP",
        "Foam Seat & Fiber Pillow Package":"CFP",
      }
    },
  },
};
</script>
<style scoped>
.panel--cushion {
  display: flex;
  justify-content: space-evenly;
}
</style>
